/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useContext } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import {
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Card,
  Box,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import SummarizeIcon from '@mui/icons-material/Summarize';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import CelebrationIcon from '@mui/icons-material/Celebration';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import { useForm, Controller } from 'react-hook-form';
import { getStorage } from '../../utils/functions/localstorage';
import { PassportAuth } from '../../contexts/AuthContext';
import Loading from '../../components/Loading';
import PaymentService from '../../components/Dialog/PaymentService';
import inetLogo from '../../assets/images/inetLogoBW.svg';

function Login() {
  const { handleSignin } = useContext(PassportAuth);
  const navigate = useNavigate();
  const { register, handleSubmit, control } = useForm({
    defaultValues: {
      typeTax: 'citizen',
    },
  });

  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState(false);
  const [checked, setChecked] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    setToken(!!getStorage('token'));
    return () => {};
  }, []);

  // const handleChangeCheckbox = (event) => {
  //   setChecked(event.target.checked);
  // };
  const handleClickOpen = () => () => {
    setOpen(true);
  };

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      // REMOVE SPACE
      const email = data.email.replace(/\s+/g, '');
      const password = data.password.replace(/\s+/g, '');
      const taxId = data.taxId.replace(/\s+/g, '');
      const { typeTax } = data;
      await handleSignin(email, password, taxId, typeTax);
      navigate('/');
    } catch (error) {
      console.error(error);
      alert('เข้าสู่ระบบไม่สำเร็จ');
      setIsLoading(false);
    }
  };
  return token ? (
    <Navigate to="/" />
  ) : (
    <div
      className="min-h-screen"
      style={{
        background:
          'linear-gradient(109.14deg, rgba(200, 253, 215, 1)-3.06%, rgba(168, 213, 255, 1) 96.16%)',
      }}
    >
      <Loading isLoading={isLoading} />
      <div>
        <div className="flex flex-wrap">
          <div className="hidden lg:block w-2/5 ">
            <div className="flex flex-col p-12">
              <div className="flex flex-row gap-6 my-6">
                <div>
                  <div className="rounded-full bg-white p-2">
                    <LocalMallIcon fontSize="large" sx={{ color: '#EAAE3B' }} />
                  </div>
                </div>

                <div>
                  <div className="font-bold">สินค้าและบริการ</div>
                  <div className="text-sm">
                    ลิ้งค์ไปที่ one portal สมัครแพ็กเกจสินค้าและบริการ
                  </div>
                </div>
              </div>
              <div className="flex flex-row gap-6 my-6">
                <div>
                  <div className="rounded-full bg-white p-2">
                    <NoteAltIcon fontSize="large" sx={{ color: '#4b8bc6' }} />
                  </div>
                </div>

                <div>
                  <div className="font-bold">สัญญาบริการ</div>
                  <div className="text-sm">
                    ตรวจสอบบริการปัจจุบัน รายละเอียดบริการ เช็คค่าบริการ
                    e-Invoice, e-Recieve
                  </div>
                </div>
              </div>
              <div className="flex flex-row gap-6 my-6">
                <div>
                  <div className="rounded-full bg-white p-2">
                    <ReceiptLongIcon
                      fontSize="large"
                      sx={{ color: '#53c086' }}
                    />
                    {' '}
                  </div>
                </div>

                <div>
                  <div className="font-bold">จ่ายบิล</div>
                  <div className="text-sm">
                    เพิ่มความสะดวกสบายให้ชีวิตออนไลน์ที่สมบูรณ์แบบ
                    กับช่องทางในการชำระค่าสินค้าและบริการตลอด 24 ชม. ปลอดภัย
                    มั่นใจ สะดวก ง่าย แค่ปลายนิ้ว
                  </div>
                </div>
              </div>
              <div className="flex flex-row gap-6 my-6">
                <div>
                  <div className="rounded-full bg-white p-2">
                    <CelebrationIcon
                      fontSize="large"
                      sx={{ color: '#d55252' }}
                    />
                    {' '}
                  </div>
                </div>

                <div>
                  <div className="font-bold">พอยท์ & สิทธิพิเศษ </div>
                  <div className="text-sm">
                    เพิ่มความสุข ด้วยส่วนลดพิเศษที่มากกว่า เพียงล็อกอิน จ่ายบิล
                  </div>
                </div>
              </div>
              <div className="flex flex-row gap-6 my-6">
                <div>
                  <div className="rounded-full bg-white p-2">
                    <SwitchAccountIcon
                      fontSize="large"
                      sx={{ color: '#ad8bdb' }}
                    />
                    {' '}
                  </div>
                </div>

                <div>
                  <div className="font-bold">ข้อมูลของคุณ</div>
                  <div className="text-sm">
                    ตรวจสอบและอัพเดทข้อมูลของคุณได้ตลอดเวลา
                    ไม่ว่าจะเป็นที่อยู่ในการจัดส่งเอกสาร หรือข้อมูลส่วนตัวอื่นๆ
                    เพื่อให้ไม่พลาดทุกข่าวสาร และสิทธิพิเศษที่มอบให้
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-3/5 h-full">
            <div className="py-24 px-2 md:p-12 h-full">
              <div className="bg-white rounded-md py-8">
                <Box>
                  <Grid container spacing={3}>
                    <Grid item xs />
                    <Grid item xs={8}>
                      <div className="grid justify-items-center ">
                        <img
                          src={inetLogo}
                          alt="img"
                          className="max-h-16 md:max-h-36  opacity-90"
                        />

                        <div className="py-4 flex flex-wrap text-center whitespace-nowrap">
                          <div className="w-full md:w-2/5 px-1 ">
                            e-Billing Payment
                          </div>
                          <div className="w-full md:w-3/5 px-1  whitespace-nowrap ">
                            ระบบแสดงค่าบริการและรับชำระออนไลน์
                          </div>
                        </div>
                      </div>
                      <Box noValidate>
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <div className="flex flex-row">
                            <div className="basis-1/12 flex items-center">
                              <PersonIcon sx={{ alignItems: 'center' }} />
                            </div>
                            <div className="basis-full">
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="ชื่อผู้ใช้งาน"
                                {...register('email')}
                                name="email"
                                autoComplete="email"
                                size="small"
                                autoFocus
                              />
                            </div>
                          </div>

                          {/* <div className="flex flex-row">
                            <div className="basis-1/12 flex items-center">
                              <LockIcon sx={{ alignItems: 'center' }} />
                            </div>
                            <div className="basis-full">
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="รหัสผ่าน"
                                type="password"
                                id="password"
                                 {...register('password')}
                                size="small"
                                autoComplete="current-password"
                              />
                            </div>
                          </div> */}
                          <div className="flex flex-row">
                            <div className="basis-1/12 flex items-center">
                              <LockIcon sx={{ alignItems: 'center' }} />
                            </div>
                            <div className="basis-full">
                              <FormControl
                                variant="outlined"
                                size="small"
                                fullWidth
                              >
                                <InputLabel htmlFor="password">
                                  Password
                                </InputLabel>
                                <OutlinedInput
                                  id="password"
                                  {...register('password')}
                                  type={showPassword ? 'text' : 'password'}
                                  endAdornment={(
                                    <InputAdornment position="end">
                                      <IconButton
                                        aria-label="password"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                      >
                                        {showPassword ? (
                                          <VisibilityOff />
                                        ) : (
                                          <Visibility />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  )}
                                  label="Password"
                                />
                              </FormControl>
                            </div>
                          </div>

                          <div className="flex flex-row">
                            <div className="basis-1/12 flex items-center">
                              <SummarizeIcon sx={{ alignItems: 'center' }} />
                            </div>
                            <div className="basis-full">
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="taxId"
                                name="taxId"
                                label="เลขประจำตัวผู้เสียภาษี"
                                {...register('taxId')}
                                autoComplete="taxId"
                                size="small"
                              />
                            </div>
                          </div>
                          <div className="grid justify-center">
                            <Controller
                              rules={{ required: true }}
                              control={control}
                              name="typeTax"
                              render={({ field }) => (
                                <RadioGroup
                                  {...field}
                                  row
                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                  name="row-radio-buttons-group"
                                >
                                  <FormControlLabel
                                    value="citizen"
                                    control={<Radio />}
                                    label="บุคคลธรรมดา"
                                    sx={{ mr: 8 }}
                                  />
                                  <FormControlLabel
                                    value="business"
                                    control={<Radio />}
                                    label="นิติบุคคล"
                                  />
                                </RadioGroup>
                              )}
                            />
                          </div>

                          <div className="flex flex-row  py-2">
                            <div className=" flex items-center">
                              <FormControlLabel
                                control={(
                                  <Controller
                                    name="policyCheck"
                                    control={control}
                                    render={({ field: props }) => (
                                      <Checkbox
                                        required
                                        {...props}
                                        checked={props.value}
                                        onChange={(e) => props.onChange(e.target.checked)}
                                      />
                                    )}
                                  />
                                )}
                                label=""
                              />
                              {/* <Checkbox
                                rules={{ required: true }}
                                checked={checked}
                                onChange={handleChangeCheckbox}
                                inputProps={{ 'aria-label': 'controlled' }}
                                {...register('')}
                              /> */}
                            </div>
                            <div className="flex flex-row items-center text-xs">
                              <div>
                                ยอมรับ
                                <span
                                  className="text-green-500 hover:text-green-300 cursor-pointer"
                                  onClick={handleClickOpen()}
                                >
                                  ข้อกำหนดการใช้บริการระบบรับชำระเงิน
                                </span>
                                และ
                                <span
                                  className="text-green-500 hover:text-green-300  cursor-pointer"
                                  onClick={handleClickOpen()}
                                >
                                  นโยบายความคุ้มครองข้อมูลส่วนบุคคล
                                </span>
                              </div>
                            </div>
                          </div>
                          {/* <div className="grid justify-items-center px-6 py-2"> */}
                          <div className="flex flex-row pb-6">
                            <div className="basis-1/12 flex items-center">
                              {/* <PersonIcon sx={{ alignItems: 'center' }} /> */}
                            </div>
                            <Button
                              type="submit"
                              variant="contained"
                              sx={{
                                backgroundColor: '#3FC37C',
                              }}
                              fullWidth
                            >
                              <div className="text-white">เข้าสู่ระบบ</div>
                            </Button>
                          </div>
                        </form>
                        <div className="flex flex-row">
                          <div className="basis-1/12" />
                          <div className="basis-full">
                            <Link
                              href="https://one.th/type_forgot_password"
                              variant="body2"
                            >
                              ลืมรหัสผ่าน?
                            </Link>
                          </div>
                        </div>
                      </Box>
                    </Grid>
                    <Grid item xs />
                  </Grid>
                </Box>
              </div>
            </div>
          </div>
        </div>
        {/* <Grid container>

          <Grid item md={4}>
            <Box sx={{ mt: 13 }}>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <button className="rounded-full bg-white p-4">
                    <LocalMallIcon fontSize="large" sx={{ color: '#EAAE3B' }} />
                  </button>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body1" gutterBottom>
                    สินค้าและบริการ ลิ้งค์ไปที่ one portal
                    สมัครแพ็กเกจสินค้าและบริการ
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 3 }}>
                <Grid item xs={2}>
                  <button className="rounded-full bg-white p-4">
                    <NoteAltIcon fontSize="large" sx={{ color: '#4b8bc6' }} />
                  </button>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body1" gutterBottom>
                    สัญญาบริการ ตรวจสอบบริการปัจจุบัน รายละเอียดบริการ
                    เช็คค่าบริการ e-Invoice, e-Recieve
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 3 }}>
                <Grid item xs={2}>
                  <button className="rounded-full bg-white p-4">
                    <ReceiptLongIcon
                      fontSize="large"
                      sx={{ color: '#53c086' }}
                    />
                  </button>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body1" gutterBottom>
                    จ่ายบิล เพิ่มความสะดวกสบายให้ชีวิตออนไลน์ที่สมบูรณ์แบบ
                    กับช่องทางในการชำระค่าสินค้าและบริการตลอด 24 ชม. ปลอดภัย
                    มั่นใจ สะดวก ง่าย แค่ปลายนิ้ว
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 3 }}>
                <Grid item xs={2}>
                  <button className="rounded-full bg-white p-4">
                    <CelebrationIcon
                      fontSize="large"
                      sx={{ color: '#d55252' }}
                    />
                  </button>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body1" gutterBottom>
                    พอยท์ & สิทธิพิเศษ เพิ่มความสุข ด้วยส่วนลดพิเศษที่มากกว่า
                    เพียงล็อกอิน จ่ายยิล
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 3 }}>
                <Grid item xs={2}>
                  <button className="rounded-full bg-white p-4">
                    <SwitchAccountIcon
                      fontSize="large"
                      sx={{ color: '#ad8bdb' }}
                    />
                  </button>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body1" gutterBottom>
                    ข้อมูลของคุณ ตรวจสอบและอัพเดทข้อมูลของคุณได้ตลอดเวลา
                    ไม่ว่าจะเป็นที่อยู่ในการจัดส่งเอกสาร หรือข้อมูลส่วนตัวอื่นๆ
                    เพื่อให้ไม่พลาดทุกข่าวสาร และสิทธิพิเศษที่มอบให้
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item md={8}>
            <Box sx={{ padding: 5 }}>
              <Grid container spacing={3}>
                <Grid item xs />
                <Grid item xs={8}>
                  <div className="grid justify-items-center mt-10">
                    <Typography component="h1" variant="h6">
                      e-Billing Payment | ระบบแสดงค่าบริการและรับชำระออนไลน์
                    </Typography>
                    <Typography sx={{ marginTop: 3 }} variant="h6" gutterBottom>
                      เข้าสู่ระบบ
                    </Typography>
                  </div>
                  <Box noValidate>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="flex flex-row">
                        <div className="basis-1/12 flex items-center">
                          <PersonIcon sx={{ alignItems: 'center' }} />
                        </div>
                        <div className="basis-full">
                          <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="ชื่อผู้ใช้งาน"
                            {...register('email')}
                            name="email"
                            autoComplete="email"
                            autoFocus
                          />
                        </div>
                      </div>

                      <div className="flex flex-row">
                        <div className="basis-1/12 flex items-center">
                          <LockIcon sx={{ alignItems: 'center' }} />
                        </div>
                        <div className="basis-full">
                          <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="รหัสผ่าน"
                            {...register('password')}
                            type="password"
                            id="password"
                            autoComplete="current-password"
                          />
                        </div>
                      </div>

                      <div className="flex flex-row">
                        <div className="basis-1/12 flex items-center">
                          <SummarizeIcon sx={{ alignItems: 'center' }} />
                        </div>
                        <div className="basis-full">
                          <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="taxId"
                            name="taxId"
                            label="เลขประจำตัวผู้เสียภาษี"
                            {...register('taxId')}
                            autoComplete="taxId"
                          />
                        </div>
                      </div>
                      <div className="grid justify-center">
                        <Controller
                          rules={{ required: true }}
                          control={control}
                          name="typeTax"
                          render={({ field }) => (
                            <RadioGroup
                              {...field}
                              row
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              name="row-radio-buttons-group"
                            >
                              <FormControlLabel
                                value="citizen"
                                control={<Radio />}
                                label="บุคคลธรรมดา"
                                sx={{ mr: 8 }}
                              />
                              <FormControlLabel
                                value="business"
                                control={<Radio />}
                                label="นิติบุคคล"
                              />
                            </RadioGroup>
                          )}
                        />
                      </div>

                      <div className="flex flex-row mt-3">
                        <div className=" flex items-center">
                          <Checkbox
                            checked={checked}
                            onChange={handleChangeCheckbox}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        </div>
                        <div className="flex items-center">
                          <Typography
                            sx={{ marginTop: 1 }}
                            variant="body2"
                            gutterBottom
                          >
                            ยอมรับ
                            <Button onClick={handleClickOpen()}>
                              ข้อกำหนดการใช้บริการระบบรับชำระเงิน
                            </Button>
                            และ
                            <Button onClick={handleClickOpen()}>
                              นโยบายความคุ้มครองข้อมูลส่วนบุคคล
                            </Button>
                          </Typography>
                        </div>
                      </div>
                      <div className=" grid justify-items-center">
                        <Button
                          type="submit"
                          variant="contained"
                          sx={{
                            mt: 3,
                            mb: 2,
                            backgroundColor: '#3FC37C',
                            width: 450,
                          }}
                        >
                          <div className="text-white">Sign In</div>
                        </Button>
                      </div>
                    </form>
                    <div className=" flex justify-between mt-5">
                      <div>
                        <span>ไม่มีบัญชี ? </span>
                        <Link
                          href="https://one.th/register"
                          // variant="body2"
                        >
                          <span className="text-white">สมัครสมาชิก</span>
                        </Link>
                      </div>
                      <div>
                        <Link href="https://one.th/type_forgot_password">
                          <span className="text-white">ลืมระหัสผ่าน</span>
                        </Link>
                      </div>
                    </div>
                  </Box>
                </Grid>
                <Grid item xs />
              </Grid>
            </Box>
          </Grid>
        </Grid>
       */}
      </div>
      <PaymentService open={open} setOpen={setOpen} />
    </div>
  );
}

export default Login;
